// @flow
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';

const getTranslationsState = state => state.translations || fromJS({});

export const getTranslationsLoading = createSelector([getTranslationsState], translations => {
    return translations.get('loading');
});

export const getTranslationsError = createSelector([getTranslationsState], translations => translations.get('error'));

export const getTranslations = createSelector([getTranslationsState], translations => translations.get('translations'));



// WEBPACK FOOTER //
// ./src/core/state/translations/selectors.js